import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * 회원가입 요청
 * @param {Object} data - 회원가입 정보
 * @returns {Promise<Object>} 서버 응답 데이터
 */
export const userSignUp = async (data) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/mobile/sign`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("회원가입 요청 오류:", error);
    throw error;
  }
};
